import {formatedPrice} from "./utils/common";
import {CERTIFICATE_TYPE_NAME, FormType} from "./utils/consts";

const PriceValue = {
  MIN: 1000,
  MAX: 50000,
};

const PRICE_VALUE_MIN_LENGTH = 5;

const certificateWrapperNode = document.querySelector(`.js-certificate`);

const setCertificateElementClass = (value, certificateElement) => {
  if (value.length >= PRICE_VALUE_MIN_LENGTH) {
    certificateElement.classList.add(`form__certificate-wrapper--max`);
  } else {
    certificateElement.classList.remove(`form__certificate-wrapper--max`);
  }
};

const setCertificateTextContent = (value, certificatePriceElement) => {
  certificatePriceElement.textContent = formatedPrice(value);
};

export const certificate = () => {
  if (certificateWrapperNode) {
    const formElement = certificateWrapperNode.querySelector(`.js-form-cert`);
    const denominationInputElement = formElement.querySelector(`.js-c-denomination`);
    const certificateElement = certificateWrapperNode.querySelector(`.js-c-content`);
    const denominationSelectElement = certificateWrapperNode.querySelector(`.js-c-denomination-select`);
    const certificatePriceElement = certificateElement.querySelector(`.js-c-price`);

    let currentCertificateTypeValue = formElement[CERTIFICATE_TYPE_NAME].value;

    const changeMinMaxValue = (input) => {
      if (input.value > PriceValue.MAX) {
        input.value = PriceValue.MAX;
      } else if (input.value < PriceValue.MIN && input.value.length) {
        input.value = PriceValue.MIN;
      }
    };

    const onInputElementBlur = (evt) => {
      const self = evt.currentTarget;

      changeMinMaxValue(self);

      setCertificateElementClass(self.value, certificateElement);

      setCertificateTextContent(self.value, certificatePriceElement);
    };

    const changeFormType = (type) => {
      switch (type) {
        case FormType.electronic:
          formElement.classList.add(`form__block--electronical`);
          break;
        case FormType.PHYSICAL:
          formElement.classList.remove(`form__block--electronical`);
          denominationInputElement.setAttribute(`disabled`, `disabled`);
          break;
      }
    };

    const onTypeRadioChange = () => {
      const newTypeValue = formElement[CERTIFICATE_TYPE_NAME].value;

      if (currentCertificateTypeValue !== formElement[CERTIFICATE_TYPE_NAME].value) {
        changeFormType(newTypeValue);
        currentCertificateTypeValue = newTypeValue;
      }
    };

    const onCertificateSelectChange = (evt) => {
      const self = evt.currentTarget;
      const value = self.value !== `choise` ? self.value : 0;

      setCertificateElementClass(value, certificateElement);
      setCertificateTextContent(value, certificatePriceElement);
    };

    denominationInputElement.addEventListener(`blur`, onInputElementBlur);
    denominationSelectElement.addEventListener(`change`, onCertificateSelectChange);

    Array.from(formElement[CERTIFICATE_TYPE_NAME]).forEach((typeRadioElement) =>
      typeRadioElement.addEventListener(`change`, onTypeRadioChange),
    );
  }
};

export const resetCertificateValue = () => {
  if (certificateWrapperNode) {
    const certificatePriceElement = certificateWrapperNode.querySelector(`.js-c-price`);
    const certificateElement = certificateWrapperNode.querySelector(`.js-c-content`);

    setCertificateElementClass(PriceValue.MIN, certificateElement);
    setCertificateTextContent(PriceValue.MIN, certificatePriceElement);
  }
};
